import axios from 'axios'
import { defineStore } from 'pinia'
import utils from "@/utils/utils.js";

const ENTRIES_PAGE = 9;
export const recipesStore = defineStore('recipes', {
    state: () => {
        return {
            itemsFeatured: {},
            recipes: {
                viewPage: 1,
                items: {},
                lastFilters: {
                    category: null,
                    text: null,
                },
                maxItems: null,
            },
            categories: {},
        }
    },
    getters: {
        getRecipes: (state) => (page) => {
            return state.recipes.items[page];
        },
        getRecipe: (state) => (slug) => {
            let recipe = null;
            if(state.itemsFeatured[slug]){
                return state.itemsFeatured[slug];
            }
            Object.values(state.recipes.items).forEach(function (page) {
                if (page[slug]) {
                    recipe = page[slug];
                }
            });
            return recipe;
        },
    },
    actions: {
        async loadCategories() {
            let t = this;
            if (Object.keys(this.categories).length > 0) {
                return;
            }
            return new Promise((resolve) => {
                axios.post('recipes/categories').then(result => {
                    result.data.data.forEach(element => {
                        t.categories[element.name] = element;
                    });
                    resolve(result);
                });
            });
        },
        async loadFeaturedRecipes() {
            let t = this;
            let data = {
                "filters": [
                    {
                        name: "featured",
                        search: 1,
                    }
                ],
                "order": [
                    {
                        "name": "created_at",
                        "direction": "desc"
                    }
                ],
            }
            if(this.itemsFeatured.length > 0){
                return;
            }
            return new Promise((resolve) => {
                axios.post('recipes', data).then(result => {
                    result.data.data.forEach(element => {
                        t.itemsFeatured[element.slug] = element;
                    });
                    resolve(result);
                });
            });
        },
        async loadRecipes({ page = 1, length = ENTRIES_PAGE, textFilter = null, categoryFilter = null, } = {}) {
            let t = this;
            let filters = [];
            if (textFilter) {
                filters = utils.generateTextFilters(textFilter, ['name', 'ingredients']);
            }
            if (categoryFilter) {
                filters.push({
                    "name": 'categories.id',
                    "search": categoryFilter.id,
                });
            }
            let data = {
                "page": page,
                "length": length,
                "filters": filters,
                "order": [
                    {
                        "name": "created_at",
                        "direction": "desc"
                    }
                ],
            }
            if (this.recipes.lastFilters.textFilter != textFilter || this.recipes.lastFilters.category != categoryFilter) {
                page = 1;
                t.recipes.items = [];
            }
            if (this.recipes.items[page] != null && Object.keys(this.recipes.items[page]).length > 0) {
                return null;
            }
            return new Promise((resolve) => {
                axios.post('recipes', data).then(result => {
                    result.data.data.forEach(element => {
                        if (t.recipes.items[page] == null) {
                            t.recipes.items[page] = {}
                        }
                        t.recipes.items[page][element.slug] = element;
                    });
                    t.recipes.viewPage = page;
                    t.recipes.maxItems = result.data.recordsFiltered;

                    t.recipes.lastFilters.text = textFilter;
                    t.recipes.lastFilters.category = categoryFilter;
                    resolve(result);
                });
            });
        },
        async getRecipeCall({ slug }) {
            return new Promise((resolve) => {
                axios.get('recipes/' + slug).then(result => {
                    resolve(result);
                })
            });
        }
    }
})